/**
 * Home banner promoting the unified Shop (/shop).
 *
 * Visual rhythm matches the other home banners (eraser, refer-50/50,
 * buy-50/50, poll) so the swap when admin flips the flag is a clean
 * silhouette swap. Purple/teal palette is intentionally distinct from
 * eraser-gold and 50/50-blue — at a glance the user can tell the shop
 * banner from either single-product banner.
 */

export function shopBannerHtml() {
  return `
    <div
      class="card shop-banner"
      style="padding:8px 10px;margin-bottom:8px;background:linear-gradient(135deg,#15233F 0%,#5B2C91 100%);border-color:rgba(127,180,255,0.55);"
    >
      <a href="/shop" data-link class="row"
         style="align-items:center;gap:8px;text-decoration:none;color:inherit;min-width:0;">
        <div style="font-size:18px;line-height:1;color:#7FB4FF;flex-shrink:0;">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
               stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
               stroke-linejoin="round" aria-hidden="true" style="display:block;">
            <!-- Shopping bag icon: handles + body -->
            <path d="M6 7h12l-1 13a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 7z"/>
            <path d="M9 7V5a3 3 0 0 1 6 0v2"/>
          </svg>
        </div>
        <div class="grow" style="min-width:0;">
          <div style="color:#fff;font-weight:700;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Power up at the Shop
          </div>
          <div style="color:rgba(255,255,255,0.78);font-weight:500;font-size:10.5px;line-height:1.25;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Erasers + 50/50s in one place
          </div>
        </div>
        <span
          class="btn sm"
          style="padding:4px 10px;font-size:12px;line-height:1.2;flex-shrink:0;margin:0;background:rgba(127,180,255,0.22);border:1px solid rgba(127,180,255,0.55);color:#fff;font-weight:700;"
        >
          Shop
        </span>
      </a>
    </div>
  `;
}
